import { render, staticRenderFns } from "./durg_list_page.vue?vue&type=template&id=397c037c&scoped=true&"
import script from "./durg_list_page.vue?vue&type=script&lang=js&"
export * from "./durg_list_page.vue?vue&type=script&lang=js&"
import style0 from "./durg_list_page.vue?vue&type=style&index=0&id=397c037c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397c037c",
  null
  
)

export default component.exports